'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _messageDeleteStatus = require('../../common-message-format/constants/messageDeleteStatus');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextUpdateMessage = function (_Record) {
  _inherits(ContextUpdateMessage, _Record);

  function ContextUpdateMessage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ContextUpdateMessage);

    return _possibleConstructorReturn(this, (ContextUpdateMessage.__proto__ || Object.getPrototypeOf(ContextUpdateMessage)).call(this, _extends({}, options, {
      contexts: options.contexts && options.contexts ? (0, _immutable.fromJS)(options.contexts) : (0, _immutable.Map)()
    })));
  }

  return ContextUpdateMessage;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.CONTEXT_UPDATE), _defineProperty(_Record2, 'id', null), _defineProperty(_Record2, 'timestamp', null), _defineProperty(_Record2, 'contexts', (0, _immutable.Map)()), _defineProperty(_Record2, 'hiddenFromVisitor', false), _defineProperty(_Record2, 'messageDeletedStatus', _messageDeleteStatus.NOT_DELETED), _Record2), 'ContextUpdateMessage'));

exports.default = ContextUpdateMessage;
module.exports = exports['default'];